module.exports = __webpack_public_path__ + "static/media/physio_markus_waas.6583fa45.png";